/**
 * CHG-052 REQ-V52-010/011/012: 프로젝트 이슈 타입 설정 API 서비스
 */
import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface IssueTypeConfigScheme {
  schemeId: string;
  name: string;
  description: string | null;
  isDefault: boolean;
  isSystem: boolean;
}

export interface IssueTypeOverride {
  id: string;
  issueType: { issueTypeId: string; name: string; icon: string; color: string; customIconPath?: string | null };
  action: 'ADD' | 'REMOVE';
}

export interface ProjectIssueTypeItem {
  issueTypeId: string;
  name: string;
  icon: string;
  color: string;
  customIconPath?: string | null;  // CHG-053: 커스텀 아이콘 경로
  isDefault: boolean;
  allowedChildTypes: { issueTypeId: string; name: string; icon: string }[];
  canBeRoot: boolean;
}

export interface ProjectIssueTypeConfig {
  scheme: IssueTypeConfigScheme | null;
  overrides: IssueTypeOverride[];
  issueTypes: ProjectIssueTypeItem[];
}

export interface MigrationPreviewResult {
  affectedIssues: {
    issueTypeId: string;
    issueTypeName: string;
    count: number;
    issues: { issueId: string; title: string }[];
  }[];
  totalAffected: number;
  canProceed: boolean;
}

export async function fetchProjectIssueTypeConfig(projectId: string): Promise<ProjectIssueTypeConfig> {
  const res = await api.get<ApiResponse<ProjectIssueTypeConfig>>(`/projects/${projectId}/issue-type-config`);
  return res.data.data!;
}

export async function changeProjectScheme(projectId: string, schemeId: string): Promise<ProjectIssueTypeConfig> {
  const res = await api.put<ApiResponse<ProjectIssueTypeConfig>>(`/projects/${projectId}/issue-type-config/scheme`, { schemeId });
  return res.data.data!;
}

export async function addOverride(projectId: string, issueTypeId: string, action: 'ADD' | 'REMOVE'): Promise<ProjectIssueTypeConfig> {
  const res = await api.post<ApiResponse<ProjectIssueTypeConfig>>(`/projects/${projectId}/issue-type-config/overrides`, { issueTypeId, action });
  return res.data.data!;
}

export async function removeOverride(projectId: string, issueTypeId: string): Promise<ProjectIssueTypeConfig> {
  const res = await api.delete<ApiResponse<ProjectIssueTypeConfig>>(`/projects/${projectId}/issue-type-config/overrides/${issueTypeId}`);
  return res.data.data!;
}

export async function migrationPreview(projectId: string, opts: { newSchemeId?: string; removeTypeIds?: string[] }): Promise<MigrationPreviewResult> {
  const res = await api.post<ApiResponse<MigrationPreviewResult>>(`/projects/${projectId}/issue-type-config/migration-preview`, opts);
  return res.data.data!;
}
